import * as React from 'react';
import './Canvas.css';
import { IconButton, Fade, List, ListItem, ListItemText, Dialog, ListItemIcon, Select, MenuItem, DialogTitle, DialogContent, DialogActions, Button, Card, Typography } from '@material-ui/core';
import { Add, CheckBoxOutlineBlank, CheckBox, Clear } from '@material-ui/icons';
import CanvasItemForm from './CanvasItemForm';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Guid } from "guid-typescript";
import moment from 'moment';
import Loading from '../Loading';
import { _PortalState } from '../../helpers/state';
import { QueryClient, useMutation, useQuery, useQueryClient } from 'react-query';
import { promises } from 'fs';
import * as microsoftTeams from "@microsoft/teams-js";
import { green } from '@material-ui/core/colors';

let EditingSection: string;
let EditingItem: CanvasItem | undefined;

const queryClient = new QueryClient();

export const Canvas: React.FC<CanvasProps> = (props: CanvasProps) => {

  // const [isLoading, setisLoading] = React.useState<boolean>(true);
  const [DialogOpen, setDialogOpen] = React.useState<boolean>(false);
  const [DialogOpenError, setDialogOpenError] = React.useState<boolean>(false);
  // const [Canvas, setCanvas] = React.useState<CanvasClass>();

  // const queryClient = useQueryClient()

  const { isLoading, isError, data, error } = useQuery<Board>(['canvas', _PortalState.teamsContext.groupId], async () => {
    return new Promise<Board>(async (resolve, reject) => {
      microsoftTeams.initialize(() => {
        microsoftTeams.authentication.getAuthToken({
          successCallback: (token: string) => {
            fetch(_PortalState.ApiEndpoint + "/canvas?groupid=" + _PortalState.teamsContext.groupId,
              {
                method: 'GET',
                headers:
                  { "Authorization": "bearer " + token }
              })
              .then(res => res.json())
              .then((res: Board) => {
                // console.log(res);
                resolve(res);
              });
          }
        })
      });
    })
  });

  const handleClose = () => {
    setDialogOpen(false);
  }

  const hanldeSave = (section: string, item: CanvasItem) => {
    if (data) {
      const board: Board = data;
      const cursection: CanvasItem[] = getSection(board, section.toLowerCase());

      if (item.id && cursection.some(c => c.id === item.id)) {
        const value = cursection.find(c => c.id === item.id);
        if (value && item.title.length > 0) {
          value.title = item.title;
          value.status = item.status;
          if (value.id === null) {
            value.id = Guid.create().toString();
          }
        } else if (value && item.title.length === 0) {
          cursection.splice(cursection.findIndex(c => c.id === item.id), 1);
        }
      }
      else {
        cursection.push(
          {
            title: item.title,
            status: item.status,
            id: Guid.create().toString()
          }
        );
      }
      save(board);
    }
    handleClose();
  }

  const save = (board: Board) => {
    console.log('saving', board);
    microsoftTeams.authentication.getAuthToken({
      successCallback: (token: string) => {
        fetch(_PortalState.ApiEndpoint + "/canvas?groupid=" + _PortalState.teamsContext.groupId,
          {
            method: 'POST',
            headers:
              { "Authorization": "bearer " + token },
            body: JSON.stringify(board)
          })
          .then(res => res.json())
          .then((res: Board) => {
            console.log(res);
            // resolve(res);
            queryClient.invalidateQueries(['canvas', _PortalState.teamsContext.groupId]);
          });
      }
    })
  }

  const onDragEnd = (result: any) => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }

    if (data) {
      const board: Board = data;
      // inside same list
      if (source.droppableId === destination.droppableId) {
        const cursection: CanvasItem[] = getSection(board, source.droppableId);
        // console.log(cursection);
        // remove item from current index
        const i: CanvasItem = cursection[source.index];
        cursection.splice(source.index, 1);
        cursection.splice(destination.index, 0, i);
        save(board);
      } else {
        const destSection: CanvasItem[] = getSection(board, destination.droppableId);
        const sourceSection: CanvasItem[] = getSection(board, source.droppableId);
        const i: CanvasItem = sourceSection[source.index];
        // remove
        sourceSection.splice(source.index, 1);
        // add
        destSection.splice(destination.index, 0, i);
        save(board);
      }
    }
  }

  // constructor(props: CanvasProps) {
  //   super(props);

  //   this.state = {
  //     Loading: true,
  //     DialogOpen: false,
  //     DialogOpenError: false,
  //     HistoryItemSelected: 'Current'
  //   }
  // }

  // public componentDidMount() {
  //   this.loadcanvas(this.props.groupid);
  // }

  // public componentWillReceiveProps(nextProps: any) {
  //   if (nextProps.match.params.group !== this.props.groupid) {
  //     const id = nextProps.match.params.id
  //     this.loadcanvas(id);
  //   }
  // }

  // private loadcanvas = (groupid: string) => {
  //   this.setState({ Loading: true }, () => {
  //     _PortalState.authProvider.acquireTokenSilent(
  //       {
  //         scopes: ["https://bwventuresb2c.onmicrosoft.com/portal/api_access"],
  //         account: _PortalState.authProvider.getAllAccounts()[0],
  //       }).then(token => {
  //         // fetch('https://bwventuresportal-api.azurewebsites.net/api/canvas?group=' + this.props['match'].params.group
  //         fetch(_PortalState.ApiEndpoint + '/api/canvas?group=' + this.props.groupid
  //           + (this.state.HistoryItemSelected !== 'Current' ? "&date=" + moment(this.state.HistoryItemSelected).format('DD-MM-YYYY') : "")
  //           , {
  //             method: 'GET',
  //             headers: {
  //               'Authorization': 'Bearer ' + token.accessToken
  //             }
  //           })
  //           .then(res => res.json())
  //           .then(canvas => {
  //             if (!canvas.Board) {
  //               canvas.Board = {
  //                 GroupId: canvas.GroupId
  //               };
  //             }
  //             this.setState({ Loading: false, Canvas: canvas });
  //           })


  //         fetch(_PortalState.ApiEndpoint + '/api/canvashistory?group=' + this.props.groupid, {
  //           method: 'GET',
  //           headers: {
  //             'Authorization': 'Bearer ' + token.accessToken
  //           }
  //         })
  //           .then(res => res.json())
  //           .then(history => {
  //             const h: any[] = [];
  //             let f: boolean = true;
  //             history.Dates.map((d: any) => {
  //               h.push(
  //                 <MenuItem key={d} value={f ? 'Current' : d}>{f ? 'Current version' : moment(d).format('dddd MMMM Do YYYY')}</MenuItem>
  //               );
  //               f = false;
  //             })
  //             this.setState({ History: h });
  //           })
  //       });
  //   })
  // }

  if (isLoading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }
  else if (!isLoading) {
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={DialogOpen}
          onClose={handleClose}
          ria-labelledby="form-dialog-title"
        >
          <CanvasItemForm
            Section={EditingSection}
            SectionDisplayName={getSectionDisplayName(EditingSection)}
            Item={EditingItem}
            onClose={handleClose}
            onSave={hanldeSave}
          />
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={DialogOpenError}
          onClose={() => setDialogOpenError(false)}
          ria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Uh oh
            {/* {this.props.id} */}
          </DialogTitle>
          <DialogContent>
            You can only edit the current version of the canvas.
          </DialogContent>
          <DialogActions>

            <Button
              onClick={() => {
                // this.setState({ HistoryItemSelected: 'Current', DialogOpenError: false }, () => {
                //   this.loadcanvas(this.props.groupid)
                // })
              }}
              color="primary"
            >
              Switch to current version
            </Button>

            <Button onClick={() => setDialogOpenError(false)} color="primary">
              Close
            </Button>

          </DialogActions>
        </Dialog>
        <Fade in={!isLoading}>
          <DragDropContext onDragEnd={onDragEnd}>
            <div>
              {/* <div style={{ display: 'flex', position: 'absolute', width: '96%', left: '0', margin: '10px 0 0 40px', minWidth: '800px' }}>
                  <div style={{ fontSize: '25px' }}>
                    {Canvas['GroupName']}
                  </div>
                  <div style={{ marginLeft: '20px', marginRight: '22px', paddingTop: '12px' }}>
                    {Canvas['Groupdescription']}
                  </div>

                  <div style={{ marginLeft: 'auto', marginRight: '15px', paddingTop: '10px' }}>
                    <Select
                      value={this.state.HistoryItemSelected ? this.state.HistoryItemSelected : 'Current'}
                      onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
                        this.setState({ HistoryItemSelected: event.target.value }, () => {
                          this.loadcanvas(this.props.groupid);
                        });
                      }}
                      inputProps={{
                        name: 'History',
                        id: 'History',
                      }}
                    >
                      {this.state.History}
                    </Select>
                  </div>
                </div> */}

              <Card className="canvas">
                {/* <div id="canvas"> */}

                {/* Problem */}
                <div id="canvas-problem" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">Problem</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "Problem"; EditingItem = undefined; setDialogOpen(true) }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"Problem"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.problem ? data.problem.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }

                                    <ListItemText primary={
                                      <Typography
                                        component="span"
                                        variant="body2"
                                        style={{ fontSize: '12px' }}
                                        // className={classes.inline}
                                        color="textPrimary"
                                      >
                                        {value.title}
                                      </Typography>
                                    } onClick={() => { EditingSection = "Problem"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Existing alternatives */}
                <div id="canvas-existing-alternatives" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">Existing alternatives</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "existingalternatives"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"existingalternatives"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.existingAlternatives ? data.existingAlternatives.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "existingalternatives"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>


                {/* Solution */}
                <div id="canvas-solution" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">Solution</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "Solution"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"Solution"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.solution ? data.solution.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "Solution"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Key Metrics */}
                <div id="canvas-key-metrics" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">Key Metrics</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "keymetrics"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"keymetrics"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.keyMetrics ? data.keyMetrics.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "keymetrics"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* high level concepts */}
                <div id="canvas-high-level-concepts" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">High level concepts</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "highlevelconcepts"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"highlevelconcepts"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.highLevelConcepts ? data.highLevelConcepts.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "highlevelconcepts"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Value Proposition */}
                <div id="canvas-value-proposition" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">unique value proposition</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "uniquevaluepropositions"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"uniquevaluepropositions"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.uniqueValueProposition ? data.uniqueValueProposition.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "uniquevaluepropositions"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Unfair Advantage */}
                <div id="canvas-unfair-advantage" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">unfair advantage</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "unfairadvantage"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"unfairadvantage"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.unfairAdvantage ? data.unfairAdvantage.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "unfairadvantage"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Channels */}
                <div id="canvas-channels" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">channels</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "channels"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"channels"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.channels ? data.channels.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "channels"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Customer segments */}
                <div id="canvas-customer-segments" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">customer segments</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "customersegments"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"customersegments"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.customerSegments ? data.customerSegments.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "customersegments"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Earlyvangelist */}
                <div id="canvas-earlyvangalist" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">Earlyvangelist</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "earlyvangalist"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"earlyvangalist"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.earlyvengalist ? data.earlyvengalist.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "earlyvangalist"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Cost ifra */}
                <div id="canvas-cost-structure" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">Cost structure</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "coststructure"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"coststructure"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.costStructure ? data.costStructure.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "coststructure"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>

                {/* Revenue streams */}
                <div id="canvas-revenue-streams" className="segment">
                  <div>
                    <div className="segment-header-container">
                      <div className="segment-header">revenue stream</div>
                      <div>
                        <IconButton onClick={() => { EditingSection = "revenuestream"; EditingItem = undefined; setDialogOpen(true); }} >
                          <Add />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <List>
                    <Droppable droppableId={"revenuestream"}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          {data && data.revenueStream ? data.revenueStream.map((value, index) => (
                            <Draggable draggableId={value.id} index={index} key={value.title}>
                              {(provided2, snapshot2) => (
                                <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                  <ListItem role={undefined} dense={true} button={true}>
                                    {
                                      value.status === 0 &&
                                      <ListItemIcon>
                                        <CheckBoxOutlineBlank />
                                      </ListItemIcon>
                                    }
                                    {value.status === 1 &&
                                      <ListItemIcon style={{ color: '#3f51b5' }}>
                                        <CheckBox />
                                      </ListItemIcon>
                                    }
                                    {
                                      value.status === 2 &&
                                      <ListItemIcon style={{ color: '#f50057' }}>
                                        <Clear />
                                      </ListItemIcon>
                                    }
                                    <ListItemText primary={<Typography
                                      component="span"
                                      variant="body2"
                                      style={{ fontSize: '12px' }}
                                      // className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {value.title}
                                    </Typography>} onClick={() => { EditingSection = "revenuestream"; EditingItem = value; setDialogOpen(true); }} />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          )) : ""
                          }
                        </div>
                      )}
                    </Droppable>
                  </List>
                </div>
              </Card>
            </div>
          </DragDropContext>
        </Fade>
      </div>
    );
  }
  else {
    return <div />
  }
}




const getSection = (Board: Board, section: string) => {
  let cursection: CanvasItem[] = [];
  switch (section.toLowerCase()) {
    case "problem":
      if (!Board.problem) {
        Board.problem = [];
      }
      cursection = Board.problem;
      break;

    case "existingalternatives":
      if (!Board.existingAlternatives) {
        Board.existingAlternatives = [];
      }
      cursection = Board.existingAlternatives;
      break;
    case "solution":
      if (!Board.solution) {
        Board.solution = [];
      }
      cursection = Board.solution;
      break;
    case "keymetrics":
      if (!Board.keyMetrics) {
        Board.keyMetrics = [];
      }
      cursection = Board.keyMetrics;
      break;
    case "uniquevaluepropositions":
      if (!Board.uniqueValueProposition) {
        Board.uniqueValueProposition = [];
      }
      cursection = Board.uniqueValueProposition;
      break;
    case "highlevelconcepts":
      if (!Board.highLevelConcepts) {
        Board.highLevelConcepts = [];
      }
      cursection = Board.highLevelConcepts;
      break;
    case "unfairadvantage":
      if (!Board.unfairAdvantage) {
        Board.unfairAdvantage = [];
      }
      cursection = Board.unfairAdvantage;
      break;
    case "channels":
      if (!Board.channels) {
        Board.channels = [];
      }
      cursection = Board.channels;
      break;
    case "customersegments":
      if (!Board.customerSegments) {
        Board.customerSegments = [];
      }
      cursection = Board.customerSegments;
      break;
    case "earlyvangalist":
      if (!Board.earlyvengalist) {
        Board.earlyvengalist = [];
      }
      cursection = Board.earlyvengalist;
      break;
    case "coststructure":
      if (!Board.costStructure) {
        Board.costStructure = [];
      }
      cursection = Board.costStructure;
      break;
    case "revenuestream":
      if (!Board.revenueStream) {
        Board.revenueStream = [];
      }
      cursection = Board.revenueStream;
      break;
    default:
      break;
  }
  return cursection;
}

const getSectionDisplayName = (section: string) => {
  if (section === undefined) {
    return "";
  }
  switch (section.toLowerCase()) {
    case "problem":
      return "problem"
    case "existingalternatives":
      return "existing alternatives"
    case "solution":
      return "solution"
    case "keymetrics":
      return "key metric"
    case "uniquevaluepropositions":
      return "unique value proposition"
    case "highlevelconcepts":
      return "high level concepts"
    case "unfairadvantage":
      return "unfair advantage"
    case "channels":
      return "channel"
    case "customersegments":
      return "customer segment"
    case "earlyvangalist":
      return "earlyvangalist";
    case "coststructure":
      return "cost structure"
    case "revenuestream":
      return "revenue stream"
    default:
      break;
  }
  return "";
}

export default Canvas;

interface CanvasProps {
  // groupid: string;
}

// interface ICanvaState {
//   Loading: boolean;
//   Canvas?: CanvasClass;

//   History?: any[];
//   HistoryItemSelected: any;

//   DialogOpen: boolean;
//   DialogOpenError: boolean;
// }

// interface CanvasClass {
//   GroupId: string;
//   GroupName: string;
//   Groupdescription?: string;
//   Board: Board;
// }

interface Board {
  id: string;
  groupId: string;
  Version: number;
  problem: CanvasItem[];
  existingAlternatives: CanvasItem[];
  solution: CanvasItem[];
  keyMetrics: CanvasItem[];
  uniqueValueProposition: CanvasItem[];
  highLevelConcepts: CanvasItem[];
  unfairAdvantage: CanvasItem[];
  channels: CanvasItem[];
  customerSegments: CanvasItem[];
  earlyvengalist: CanvasItem[];
  costStructure: CanvasItem[];
  revenueStream: CanvasItem[];
}

export interface CanvasItem {
  id: string;
  status: number;
  title: string;
  // public Comments?: string;
}
